export enum MatchStatus {    
    NeedsMatch = 1,
    MatchOffered = 2,
    PendingCrossMatch = 3,
    PendingTransplant = 4,
    Transplanted = 5
}